export enum ActivityState {
  active = "Active",
  inactive = "Inactive",
  archived = "Archived",
}
